import { render } from "./CreateVMFromBackup.vue?vue&type=template&id=8fa350f8&scoped=true"
import script from "./CreateVMFromBackup.vue?vue&type=script&lang=js"
export * from "./CreateVMFromBackup.vue?vue&type=script&lang=js"

import "./CreateVMFromBackup.vue?vue&type=style&index=0&id=8fa350f8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa350f8"]])

export default __exports__